import axios from 'axios'
import store from '@/store'
import { setupResponseInterceptor } from './responseInterceptor'

const journeyClient = axios.create({
  baseURL: process.env.VUE_APP_JOURNEY_URL,
  withCredentials: true,
})

journeyClient.interceptors.request.use((config) => {
  config.headers.lang = store.getters['getLang']
  return config
})

setupResponseInterceptor(journeyClient)

export default journeyClient
